// src/components/logo/logo.tsx
import React from "react";
var Logo = ({ vertical = false, ...props }) => {
  if (vertical) {
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 41", ...props }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.1945 18H18V0.336495H22.1945V2.21938C23.2072 1.04165 24.7802 0 27.227 0C29.4296 0 31.072 0.942681 32.0846 2.45691C33.2026 1.31381 34.9504 0 37.7802 0C41.5558 0 44 2.55588 44 6.35876V18H39.8055V7.53649C39.8055 5.34928 38.9676 3.76825 36.7289 3.76825C34.9478 3.76825 33.0947 5.11423 33.0947 7.63794V18H28.9002V7.53649C28.9002 5.34928 28.0623 3.76825 25.8236 3.76825C24.0425 3.76825 22.1894 5.11423 22.1894 7.63794V18H22.1945Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M24.9004 40.9951C22.4061 40.9951 20.1547 40.3408 18.5609 39.1558C16.8852 37.9066 16 36.1587 16 34.1046C16 31.2778 17.4941 29.2188 20.8429 27.4339L20.935 27.3845L20.8659 27.308C19.6763 26.0168 18.4586 24.3972 18.4586 22.1679V22H22.887C22.9203 23.3381 23.9052 24.3873 25.1025 25.4489L25.1435 25.4909L25.1972 25.4687C28.0395 24.4194 29.0961 23.622 29.1933 22H33.522C33.3583 24.8638 31.153 26.4068 27.8553 27.9597L27.7479 28.0091L32.5805 32.606L32.6368 32.527C33.3327 31.5444 33.8316 30.3643 33.962 29.1077H38.5159C38.2907 31.1494 37.3569 33.3096 35.7426 35.5266L35.7017 35.5834L41 40.6272H34.814L32.6471 38.5707L32.5908 38.6102C30.3318 40.1976 27.7427 41 24.8953 41L24.9004 40.9951ZM23.4857 29.9693C21.6258 30.9914 20.8659 32.053 20.8659 33.6281C20.8659 35.381 22.2321 37.1486 25.2867 37.1486C26.9087 37.1486 28.3874 36.7191 29.6819 35.8723L29.7664 35.818L23.5394 29.9422L23.4857 29.9718V29.9693Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M55.995 40.7456H51.9136V38.7497C50.8933 39.9255 49.3628 41 47.052 41C43.3108 41 41 38.4805 41 34.6864V22H45.0814V33.8145C45.0814 35.9635 46.0342 37.3418 48.2449 37.3418C50.0805 37.3418 51.9186 35.9981 51.9186 33.4785V22H56V40.7456H55.995Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M6.5 41C10.0899 41 13 38.0899 13 34.5C13 30.9101 10.0899 28 6.5 28C2.91015 28 0 30.9101 0 34.5C0 38.0899 2.91015 41 6.5 41Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M6.5 27C10.0899 27 13 24.0899 13 20.5C13 16.9101 10.0899 14 6.5 14C2.91015 14 0 16.9101 0 20.5C0 24.0899 2.91015 27 6.5 27Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M59.4468 13.2377C58.8384 14.4423 57.0679 15.4495 55.472 15.4495C52.6129 15.4495 50.6078 13.5364 50.2722 10.4034H63.94V9.01159C63.94 4.00093 60.9309 0 55.2865 0C49.642 0 46 4.14012 46 9.5C46 15.1383 49.9012 19 55.472 19C59.3731 19 62.625 16.4567 64 13.2555L63.9509 13.2377H59.4441H59.4468ZM55.251 3.51505C58.0746 3.51505 59.4113 5.25613 59.4468 7.27304H50.4959C51.1643 4.80314 52.9485 3.51505 55.251 3.51505Z",
        fill: "currentColor"
      }
    ));
  }
  return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 80 25", ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.61632 0.503447C0.628591 1.73829 -0.790982 5.15571 0.447881 8.13741C1.68474 11.1191 5.11018 12.5327 8.09791 11.2998C11.0856 10.065 12.5032 6.64757 11.2663 3.66787C10.0295 0.684156 6.60405 -0.7314 3.61632 0.503447Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.61621 13.703C0.628482 14.9378 -0.789083 18.3552 0.447772 21.3349C1.68463 24.3166 5.11008 25.7302 8.0978 24.4974C11.0855 23.2625 12.5031 19.8451 11.2662 16.8654C10.0294 13.8837 6.60394 12.4701 3.61621 13.703Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M30.3792 4.97691C28.1805 4.97691 26.8232 6.04511 25.9558 6.97877C25.1687 5.74593 23.8937 4.97691 22.183 4.97691C20.2835 4.97691 19.0607 5.82625 18.2736 6.78601V5.24999H15.0168V19.6425H18.2736V11.1993C18.2736 9.14327 19.7113 8.04696 21.0967 8.04696C22.8335 8.04696 23.4861 9.33603 23.4861 11.117V19.6425H26.7429V11.1993C26.7429 9.14327 28.1805 8.04696 29.566 8.04696C31.3028 8.04696 31.9553 9.33603 31.9553 11.117V19.6425H35.2121V10.1572C35.2121 7.05909 33.3127 4.97691 30.3812 4.97691H30.3792Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M76.7432 5.25252V13.8061C76.7432 15.8622 75.2774 16.9585 73.8117 16.9585C72.0468 16.9585 71.2878 15.8341 71.2878 14.0792V5.25252H68.031V14.792C68.031 17.8901 69.8762 19.9462 72.862 19.9462C74.7072 19.9462 75.93 19.0688 76.7432 18.109V19.645H80V5.25252H76.7432Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M66.993 10.7016H63.4852C63.3968 11.6895 63.0756 12.599 62.5656 13.352L59.1381 9.93858C61.658 8.69771 63.1439 7.49298 63.2362 5.25018H59.9092C59.859 6.49506 59.1401 7.03719 57.1383 7.91464C56.289 7.00306 55.6946 6.26416 55.6946 5.25821V5.24817H52.1648C52.1627 5.31242 52.1607 5.37467 52.1607 5.43892C52.1607 7.12152 52.998 8.35436 53.9397 9.42255C51.464 10.804 50.3577 12.4063 50.3577 14.5929C50.3577 16.1891 51.0142 17.5464 52.2591 18.5163C53.4378 19.4359 55.0983 19.9398 56.9415 19.9398C59.0418 19.9398 60.9512 19.3194 62.6178 18.0946L64.186 19.6527H68.8924L64.9409 15.7153C65.9609 14.2495 66.8183 12.5107 66.991 10.6935V10.7016H66.993ZM57.2246 16.8718C55.03 16.8718 54.0461 15.5486 54.0461 14.2334C54.0461 13.0568 54.5943 12.2517 55.9356 11.4806L60.4111 15.902C59.4734 16.5445 58.4012 16.8718 57.2246 16.8718Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M46.093 15.3457C45.6533 16.2854 44.3722 17.0705 43.2177 17.0705C41.1476 17.0705 39.6979 15.5786 39.4549 13.135H49.3438V12.0488C49.3438 8.13941 47.1672 5.01917 43.0812 5.01917C38.9951 5.01917 36.3628 8.24985 36.3628 12.4282C36.3628 16.8255 39.1839 19.8373 43.2157 19.8373C46.0368 19.8373 48.392 17.8535 49.3859 15.3577L49.3518 15.3437H46.091H46.093V15.3457ZM43.0571 7.75992C45.0991 7.75992 46.0669 9.11725 46.093 10.6914H39.6156C40.0995 8.76386 41.3885 7.75992 43.0551 7.75992H43.0571Z",
      fill: "currentColor"
    }
  ));
};

export {
  Logo
};
